import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { EStaticPageName } from '@modules/static-pages/enums';
import { buildObjectFromArray } from '@utils/object';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            information: {
              tab_name: 'TAB_NAME',
              language: 'LANGUAGE',
              settings_type: 'TYPE',
              ...buildObjectFromArray(Object.values(EStaticPageName), 'PAGE_', 'settings_'),
            },
          },
        },
      },
    },
  }));
}
